import { ButtonProps, Fab } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import cx from 'classnames';
import React from 'react';

interface IProps {
  onClick?: () => void;
  label: string;
  Icon?: JSX.Element;
}

const useStyles = makeStyles((theme: Theme) => ({
  roundedButton: {
    width: 'auto',
    height: 52,
    borderRadius: 26,
    backgroundColor: theme.palette.background.default,
    boxShadow: '0 2px 2px 0 rgba(0, 0, 0, 0.24), 0 0 2px 0 rgba(0, 0, 0, 0.12)',
    color: theme.palette.text.primary,
    margin: '0 4px 4px 0',
    fontSize: 16,
    fontWeight: 'normal',
    textTransform: 'none',
    letterSpacing: 0,
    boxSizing: 'content-box',
    padding: '0 20px',
  },

  roundedbuttonIcon: {
    marginRight: theme.spacing(1),
    color: theme.palette.primary.main,
  },
}));

export const RoundedButton = (props: IProps & ButtonProps): JSX.Element => {
  const classes = useStyles();
  const { variant: _, onClick, label, Icon, className, ...restProps } = props;

  return (
    <Fab variant="extended" className={cx(classes.roundedButton, className)} onClick={onClick} {...restProps}>
      {Icon}
      {label}
    </Fab>
  );
};
